<div class="crm-field-read-only" id="crm-group-id-form" *ngIf="readOnly || (isInline$ | async); else formField">
  <!-- No inline editing -->
</div>
<ng-template #formField>
  <glxy-form-field *ngIf="!loadingValues(); else loadingField">
    <glxy-label>{{ 'COMMON.MARKET_SELECTOR.LABEL' | translate }}</glxy-label>
    <input
      #input
      type="text"
      matInput
      [formControl]="control"
      [matAutocomplete]="auto"
      data-testid="form-market-id-input"
      [placeholder]="'COMMON.MARKET_SELECTOR.LABEL' | translate"
      (blur)="saveField()"
      (input)="filter()"
      (focus)="filter()"
      (keydown.enter)="$event.preventDefault()"
    />
    @if (control.value) {
      <button matSuffix mat-icon-button class="crm-field-clear-button" aria-label="Clear" (click)="clear()">
        <mat-icon>close</mat-icon>
      </button>
    }
    <mat-autocomplete
      requireSelection
      #auto="matAutocomplete"
      [displayWith]="displayFn(availableOptions())"
      (optionSelected)="onOptionSelected($event.option.value)"
    >
      <mat-option *ngFor="let option of filteredOptions" [value]="option" (mousedown)="$event.preventDefault()">
        {{ option?.name }}
      </mat-option>
    </mat-autocomplete>
    @if (_control.hasError('required')) {
      <glxy-error>
        {{ 'CRM.FORMS.MARKET_REQUIRED' | translate }}
      </glxy-error>
    }
    @if (_control.hasError('invalidMarket')) {
      <glxy-error>
        {{ 'CRM.FORMS.INVALID_MARKET' | translate }}
      </glxy-error>
    }
  </glxy-form-field>
  <ng-template #loadingField>
    <glxy-form-field>
      <glxy-label>Market ID</glxy-label>
      <input type="text" disabled matInput />
      <mat-spinner matPrefix diameter="24"></mat-spinner>
    </glxy-form-field>
  </ng-template>
</ng-template>
